import store from '@/store';

import { WorkerOneTimePassConstants } from '@/core/worker-one-time-pass';

import guardUtils from '@/portal/guards/guard-utils';

const canAccessOneTimePass = {
  check: guardUtils.hasWorkerOnBoarded,
  redirectOnFail: {
    name: 'workerOnBoardingBusinessSearch',
  },
};

const hasOneTimePass = {
  check: async (to) => {
    const oneTimePass = await guardUtils.fetchOneTimePassUsingQueryParams(to);
    return !!oneTimePass;
  },
  redirectOnFail: {
    name: 'oneTimePassNotFound',
  },
};

const hasWorkerAssessment = {
  check: async () => {
    const workerAssessment = await guardUtils.fetchWorkerAssessment();
    return !!workerAssessment;
  },
};

const hasWorkerInductions = {
  check: async (to) => {
    await guardUtils.fetchWorkerOneTimePassUsingQueryParams(to);
    const workerInductions = store.getters['oneTimePass/workerInductions'];
    return !!workerInductions && workerInductions.length;
  },
  redirectOnFail: {
    name: 'oneTimePassWelcome',
  },
};

const workerCreated = {
  check: async () => {
    const worker = await guardUtils.fetchWorkerUuid() || await guardUtils.createWorkerForUser();
    return !!worker;
  },
};

const workerOneTimePassCreated = {
  check: async (to) => {
    const workerOneTimePass = await guardUtils.fetchWorkerOneTimePassUsingQueryParams(to) ||
      await guardUtils.createWorkerOneTimePass(to);
    return !!workerOneTimePass;
  },
  redirectOnFail: {
    name: 'workerOnBoardingBusinessSearch',
  },
};

const workerOTPCompleted = {
  check: async (to) => {
    const workerOneTimePassStatus = await guardUtils.fetchWorkerOneTimePassStatus(to);
    return workerOneTimePassStatus === _.get(WorkerOneTimePassConstants, 'current_status.completed.key');
  },
  redirectOnFail: {
    name: 'oneTimePassWelcome',
  },
};

const workerOTPHasAssessmentFields = {
  check: async (to) => {
    await guardUtils.fetchWorkerOneTimePassUsingQueryParams(to);
    const filteredAssessmentFields = store.getters['oneTimePass/filteredAssessmentFields'];
    return !!filteredAssessmentFields.length;
  },
  redirectOnFail: {
    name: 'oneTimePassInduction',
  },
};

const workerOTPNotCompleted = {
  check: async (to) => {
    const isCompleted = await workerOTPCompleted.check(to);
    return !isCompleted;
  },
  redirectOnFail: {
    name: 'oneTimePassSuccess',
  },
};

const workerOTPNotRedeemed = {
  check: async (to) => {
    const workerOneTimePassStatus = await guardUtils.fetchWorkerOneTimePassStatus(to);
    return workerOneTimePassStatus !== _.get(WorkerOneTimePassConstants, 'current_status.redeemed.key');
  },
  redirectOnFail: {
    name: 'oneTimePassWelcome',
  },
};

export default {
  canAccessOneTimePass,
  hasOneTimePass,
  hasWorkerAssessment,
  hasWorkerInductions,
  workerCreated,
  workerOneTimePassCreated,
  workerOTPCompleted,
  workerOTPHasAssessmentFields,
  workerOTPNotCompleted,
  workerOTPNotRedeemed,
};
